import React from 'react'

interface DocumentIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const DocumentIcon: React.FC<DocumentIconProps> = ({
  color = '#000',
  gradient,
  width = 18,
  height = 24,
  alt = 'Document icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 18 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M2 22.75h14a.75.75 0 00.75-.75V6.92a.75.75 0 00-.262-.57l-5.74-4.92a.75.75 0 00-.488-.18H2a.75.75 0 00-.75.75v20c0 .414.336.75.75.75zM2 0a2 2 0 00-2 2v20a2 2 0 002 2h14a2 2 0 002-2V6.92a2 2 0 00-.698-1.519l-5.74-4.92A2 2 0 0010.26 0H2z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M3.375 10c0-.345.28-.625.625-.625h10.018a.625.625 0 110 1.25H4A.625.625 0 013.375 10zM3.375 18c0-.345.28-.625.625-.625h4.795a.625.625 0 110 1.25H4A.625.625 0 013.375 18zM14.875 14c0 .345-.28.625-.625.625H4a.625.625 0 110-1.25h10.25c.345 0 .625.28.625.625zM12 7a2 2 0 01-2-2V0h.26a2 2 0 01.99.262V5c0 .414.336.75.75.75h5.622A2 2 0 0118 6.92V7h-6z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default DocumentIcon
